// extracted by mini-css-extract-plugin
module.exports = {"root":"lBaQ78","link":"Rs3riP"};